import {Box, Card, Divider, Typography} from '@material-ui/core';
import React from 'react';
import {IFarmer} from 'constants/interfaces';
import {Skeleton} from '@material-ui/lab';

export function FarmDetailCard(props: {farmer?: IFarmer; isLoading?: boolean}) {
  if (props.isLoading)
    return <Skeleton variant="rect" height={200} style={{borderRadius: 8}} />;
  if (!props.farmer) return null;
  const {farmer} = props;
  const farm = farmer.farm;
  const formatLatLong = (latlng?: string) => {
    if (!latlng) return latlng;
    const lat = latlng.split(',')[0];
    const lng = latlng.split(',')[1];
    if (!lat || !lng) return latlng;
    const maxLength = 15;
    return lat.substring(0, maxLength) + ', ' + lng.substring(0, maxLength);
  };
  return (
    <Card className="farmer-detail-card" variant="outlined">
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Farm</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {farm?.name}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Province</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {farm?.province}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Address</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {farmer.address || ''}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">LatLong</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {formatLatLong(farmer.farm?.latLong) || ''}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Hectares</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {farm?.sizeHectares}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Email</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {farmer.email}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Phone</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {farmer.phone}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
